// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'components' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import '../stylesheets/packs/components'

import * as SemanticComponents from 'semantic-ui-react'

import mount from 'mount'

import CreatePageSize from 'AdminApp/containers/CreatePageSize'
import CreateTemplate from 'AdminApp/containers/CreateTemplate'
import ExportMenu from 'components/ExportMenu'
import ExportPage from 'components/ExportPage'
import DocShow from 'components/DocShow'
import EditSections from 'AdminApp/containers/EditSections'
import FlashMessage from 'components/FlashMessage'
import IndexFilterer from 'components/IndexFilterer'
import Navbar from 'components/Navbar'
import NavbarLinksMenu from 'components/NavbarLinksMenu'
import PrintOptionAndQuantitySelect from 'components/PrintOptionAndQuantitySelect'
import SearchForm from 'components/SearchForm'
import DivisionSelector from 'components/DivisionSelector'
import BusinessLineSelector from 'components/BusinessLineSelector'
import BusinessLineRoleSelector from 'components/BusinessLineRoleSelector'
import DocumentIndex from 'components/DocumentIndex'

mount({
  CreatePageSize,
  CreateTemplate,
  ExportMenu,
  ExportPage,
  BusinessLineSelector,
  BusinessLineRoleSelector,
  DivisionSelector,
  DocShow,
  EditSections,
  FlashMessage,
  IndexFilterer,
  Navbar,
  NavbarLinksMenu,
  PrintOptionAndQuantitySelect,
  SearchForm,
  DocumentIndex,
  ...SemanticComponents,
})
